/* eslint-disable import/default */
import "whatwg-fetch";
import React from "react";
import { render } from "react-dom";
import "normalize.css/normalize.css";
import "theme/reset.scss";
import "theme/global.scss";
import "root/table.scss";
import "theme/generalException.scss";
import {FeatureFlagLoader} from "./containers/FeatureFlagLoader/FeatureFlagLoader";

render(
  <FeatureFlagLoader/>,
  document.getElementById("app")
);



// WEBPACK FOOTER //
// ./src/index.js